import "core-js/modules/es.function.name.js";
var getters = {
  dict: function dict(state) {
    return state.app.dict;
  },
  sidebar: function sidebar(state) {
    return state.app.sidebar;
  },
  device: function device(state) {
    return state.app.device;
  },
  token: function token(state) {
    return state.user.token;
  },
  avatar: function avatar(state) {
    return state.user.avatar;
  },
  name: function name(state) {
    return state.user.name;
  },
  staffId: function staffId(state) {
    return state.user.staffId;
  },
  staffName: function staffName(state) {
    return state.user.staffName;
  },
  staffDepartment: function staffDepartment(state) {
    return state.user.staffDepartment;
  },
  contractCount: function contractCount(state) {
    return state.user.contractCount;
  },
  roles: function roles(state) {
    return state.user.roles;
  },
  permissionList: function permissionList(state) {
    return state.permission.permissionList;
  },
  accountTypes: function accountTypes(state) {
    return state.permission.accountTypes;
  },
  currentAccount: function currentAccount(state) {
    return state.permission.currentAccount;
  },
  routes: function routes(state) {
    return state.permission.routes;
  },
  company_info: function company_info(state) {
    return state.user.company_info;
  },
  subProjectInfo: function subProjectInfo(state) {
    return state.user.subProjectInfo;
  },
  accessRecord: function accessRecord(state) {
    return state.permission.accessRecord;
  }
};
export default getters;